import React, { useState, lazy } from 'react';
import { StarIcon, ShoppingCartIcon } from 'lucide-react';
import { ExtraBonusModal } from './ExtraBonusModal';
export function RelatedProducts() {
  const [isExtraBonusModalOpen, setIsExtraBonusModalOpen] = useState(false);
  return <>
      <section id="bonos" className="bg-gray-50 py-8 sm:py-12 md:py-16" data-id="element-523">
        <div className="max-w-6xl mx-auto px-4" data-id="element-524">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3 sm:mb-4" data-id="element-525">
            Bonos Incluidos con Tu Compra
          </h2>
          <p className="text-center text-sm sm:text-base md:text-lg text-gray-600 mb-8 sm:mb-12 px-4" data-id="element-526">
            Recibe estos libros GRATIS al comprar las 50 Recetas de 15 Minutos
          </p>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-527">
            <div className="bg-white rounded-lg p-4 sm:p-6 border-4 border-orange-300 relative" data-id="element-528">
              <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2" data-id="element-529">
                <div className="bg-orange-600 text-white px-4 py-1.5 sm:px-6 sm:py-2 rounded-full text-xs sm:text-sm font-bold shadow-lg whitespace-nowrap" data-id="element-530">
                  🎁 BONUS 1 - GRATIS
                </div>
              </div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1MimqiDvJf4TfAvy8WG7Mq/PORTADA_Loncheras.png" alt="Loncheras que Los Niños Devoran" loading="lazy" className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg mb-3 sm:mb-4 mt-3 sm:mt-4" data-id="element-531" />
              <div className="flex items-center gap-2 mb-2" data-id="element-532">
                <div className="flex" data-id="element-533">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400" data-id="element-534" />)}
                </div>
                <span className="text-xs sm:text-sm text-gray-600" data-id="element-535">
                  892 Familias
                </span>
              </div>
              <h3 className="font-bold text-base sm:text-lg md:text-xl mb-2 sm:mb-3 text-orange-600" data-id="element-536">
                Loncheras que Los Niños Devoran
              </h3>
              <p className="text-xs sm:text-sm text-gray-700 mb-3 sm:mb-4 leading-relaxed" data-id="element-537">
                50 ideas de loncheras escolares nutritivas y rápidas. Que tus
                hijos lleven comida casera sin que te tome horas prepararla.
              </p>
              <div className="bg-orange-50 p-2.5 sm:p-3 rounded-lg mb-3 sm:mb-4" data-id="element-538">
                <div className="font-semibold mb-1.5 sm:mb-2 text-xs sm:text-sm" data-id="element-539">
                  Incluye:
                </div>
                <ul className="text-xs text-gray-700 space-y-0.5 sm:space-y-1" data-id="element-540">
                  <li data-id="element-541">• 50 ideas de loncheras completas</li>
                  <li data-id="element-542">• Opciones nutritivas y atractivas</li>
                  <li data-id="element-543">• Tips de conservación</li>
                </ul>
              </div>
              <div className="flex items-center justify-center gap-2 mb-2 sm:mb-3" data-id="element-544">
                <span className="text-xl sm:text-2xl font-bold text-orange-600" data-id="element-545">
                  GRATIS
                </span>
                <span className="text-gray-500 line-through text-base sm:text-lg" data-id="element-546">
                  $37
                </span>
              </div>
              <div className="text-center text-xs text-green-600 font-semibold" data-id="element-547">
                ✓ Incluido automáticamente
              </div>
            </div>
            <div className="bg-white rounded-lg p-4 sm:p-6 border-4 border-orange-300 relative" data-id="element-548">
              <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2" data-id="element-549">
                <div className="bg-orange-600 text-white px-4 py-1.5 sm:px-6 sm:py-2 rounded-full text-xs sm:text-sm font-bold shadow-lg whitespace-nowrap" data-id="element-550">
                  🎁 BONUS 2 - GRATIS
                </div>
              </div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cqc1NXhh87XUiy6dr7yk8D/portd_15_minut.png" alt="7 Días de Cena en 15 Minutos" loading="lazy" className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg mb-3 sm:mb-4 mt-3 sm:mt-4" data-id="element-551" />
              <div className="flex items-center gap-2 mb-2" data-id="element-552">
                <div className="flex" data-id="element-553">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400" data-id="element-554" />)}
                </div>
                <span className="text-xs sm:text-sm text-gray-600" data-id="element-555">
                  1,156 Familias
                </span>
              </div>
              <h3 className="font-bold text-base sm:text-lg md:text-xl mb-2 sm:mb-3 text-orange-600" data-id="element-556">
                7 Días de Cena en 15 Minutos
              </h3>
              <p className="text-xs sm:text-sm text-gray-700 mb-3 sm:mb-4 leading-relaxed" data-id="element-557">
                Plan completo de una semana con 7 cenas diferentes. Cada una
                lista en 15 minutos exactos.
              </p>
              <div className="bg-orange-50 p-2.5 sm:p-3 rounded-lg mb-3 sm:mb-4" data-id="element-558">
                <div className="font-semibold mb-1.5 sm:mb-2 text-xs sm:text-sm" data-id="element-559">
                  Incluye:
                </div>
                <ul className="text-xs text-gray-700 space-y-0.5 sm:space-y-1" data-id="element-560">
                  <li data-id="element-561">• 7 recetas para la semana</li>
                  <li data-id="element-562">• Lista de compras organizada</li>
                  <li data-id="element-563">• Guía paso a paso</li>
                </ul>
              </div>
              <div className="flex items-center justify-center gap-2 mb-2 sm:mb-3" data-id="element-564">
                <span className="text-xl sm:text-2xl font-bold text-orange-600" data-id="element-565">
                  GRATIS
                </span>
                <span className="text-gray-500 line-through text-base sm:text-lg" data-id="element-566">
                  $27
                </span>
              </div>
              <div className="text-center text-xs text-green-600 font-semibold" data-id="element-567">
                ✓ Incluido automáticamente
              </div>
            </div>
            <div className="bg-white rounded-lg p-4 sm:p-6 border-4 border-orange-300 relative sm:col-span-2 md:col-span-1" data-id="element-568">
              <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2" data-id="element-569">
                <div className="bg-orange-600 text-white px-4 py-1.5 sm:px-6 sm:py-2 rounded-full text-xs sm:text-sm font-bold shadow-lg whitespace-nowrap" data-id="element-570">
                  🎁 BONUS 3 - GRATIS
                </div>
              </div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hobPN8rfhRv3SHgaek9vd1/Portada_ebook_kit_de_menu.png" alt="Kit Imprimible de Menús" loading="lazy" className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg mb-3 sm:mb-4 mt-3 sm:mt-4" data-id="element-571" />
              <div className="flex items-center gap-2 mb-2" data-id="element-572">
                <div className="flex" data-id="element-573">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400" data-id="element-574" />)}
                </div>
                <span className="text-xs sm:text-sm text-gray-600" data-id="element-575">
                  743 Familias
                </span>
              </div>
              <h3 className="font-bold text-base sm:text-lg md:text-xl mb-2 sm:mb-3 text-orange-600" data-id="element-576">
                Kit Imprimible de Menús
              </h3>
              <p className="text-xs sm:text-sm text-gray-700 mb-3 sm:mb-4 leading-relaxed" data-id="element-577">
                Plantillas imprimibles para organizar tus menús semanales. Pega
                en tu refrigerador y que toda la familia sepa qué hay de comer.
              </p>
              <div className="bg-orange-50 p-2.5 sm:p-3 rounded-lg mb-3 sm:mb-4" data-id="element-578">
                <div className="font-semibold mb-1.5 sm:mb-2 text-xs sm:text-sm" data-id="element-579">
                  Incluye:
                </div>
                <ul className="text-xs text-gray-700 space-y-0.5 sm:space-y-1" data-id="element-580">
                  <li data-id="element-581">• Plantillas de menú semanal</li>
                  <li data-id="element-582">• Listas de compras imprimibles</li>
                  <li data-id="element-583">• Organizadores de cocina</li>
                </ul>
              </div>
              <div className="flex items-center justify-center gap-2 mb-2 sm:mb-3" data-id="element-584">
                <span className="text-xl sm:text-2xl font-bold text-orange-600" data-id="element-585">
                  GRATIS
                </span>
                <span className="text-gray-500 line-through text-base sm:text-lg" data-id="element-586">
                  $19
                </span>
              </div>
              <div className="text-center text-xs text-green-600 font-semibold" data-id="element-587">
                ✓ Incluido automáticamente
              </div>
            </div>
          </div>
          <div className="mt-8 sm:mt-12 text-center" data-id="element-588">
            <div className="bg-orange-600 text-white py-3 px-6 sm:py-4 sm:px-8 rounded-lg inline-block" data-id="element-589">
              <div className="text-xs sm:text-sm font-semibold mb-1" data-id="element-590">
                VALOR TOTAL DE LOS BONOS
              </div>
              <div className="text-2xl sm:text-3xl font-bold" data-id="element-591">
                $250.00 USD GRATIS
              </div>
            </div>
            <p className="mt-3 sm:mt-4 text-sm sm:text-base text-gray-600 px-4" data-id="element-592">
              Solo pagas por el libro principal de 50 Recetas ($9.95 USD)
            </p>
            <div className="mt-6 sm:mt-8 text-center px-4" data-id="element-593">
              <div className="inline-block relative" data-id="element-594">
                {/* Glow Effect Background */}
                <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-500 blur-2xl opacity-30 animate-pulse" data-id="element-595"></div>

                {/* Premium Text */}
                <p className="relative text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-amber-500 via-orange-600 to-amber-500 bg-clip-text text-transparent leading-tight py-2" style={{
                textShadow: '0 0 30px rgba(251,191,36,0.3)'
              }} data-id="element-596">
                  ✨ Solo Pagas $9.95 USD ✨
                  <br data-id="element-597" />
                  <span className="text-lg sm:text-xl md:text-2xl" data-id="element-598">
                    ¡Acceso Completo a los 7 Libros Premium!
                  </span>
                </p>
              </div>
            </div>
            <a href="https://mikioscodigital.com/cart/51606060794137:1?checkout" target="_blank" rel="noopener noreferrer" className="group relative mt-6 sm:mt-8 inline-flex items-center justify-center gap-3 px-8 py-4 sm:px-10 sm:py-5 rounded-full bg-gradient-to-br from-amber-300 via-amber-500 to-amber-600 text-gray-900 font-bold text-lg sm:text-xl tracking-wide shadow-[0_0_20px_rgba(245,158,11,0.5)] hover:shadow-[0_0_40px_rgba(245,158,11,0.8)] hover:scale-105 hover:-translate-y-1 transition-all duration-300 mx-auto w-fit overflow-hidden border-2 border-amber-200/50" data-id="element-599">
              {/* 3D Shine Overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-white/10 to-transparent opacity-100 pointer-events-none rounded-full" data-id="element-600"></div>

              {/* Animated Glow Pulse */}
              <div className="absolute inset-0 rounded-full bg-amber-400/30 blur-xl animate-pulse" data-id="element-601"></div>

              <ShoppingCartIcon className="relative z-10 w-6 h-6 sm:w-7 sm:h-7 drop-shadow-md" data-id="element-602" />
              <span className="relative z-10 drop-shadow-md uppercase" data-id="element-603">
                QUIERO MI PACK DE 15 MINUTOS AHORA!!!
              </span>
            </a>
            <p className="text-xs sm:text-sm text-gray-600 mt-2 sm:mt-3 text-center" data-id="element-604">
              Valor $250, Hoy Solo $9.95 USD
            </p>
            <button onClick={() => setIsExtraBonusModalOpen(true)} className="mt-3 sm:mt-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-5 py-2.5 sm:px-6 sm:py-3 rounded-lg font-bold text-base sm:text-lg hover:from-purple-700 hover:to-pink-700 transition shadow-lg mx-auto block animate-pulse" data-id="element-605">
              🎉 ¡Super Regalo Extra!!! 🎉
            </button>
          </div>
        </div>
      </section>
      <ExtraBonusModal isOpen={isExtraBonusModalOpen} onClose={() => setIsExtraBonusModalOpen(false)} data-id="element-606" />
    </>;
}